/* eslint-disable */
import styles from './index.module.scss'
import Useful from '../../components/pages/useful'
import translate from '../../utils/translate.json'
import { PageContext } from '../../context/PageContextProvider'
import { useParams } from 'react-router-dom'
import { useState, useContext, useEffect } from 'react'
import { Button, FormButton } from '../../components/core/button'
import PagesAPI from '../../api/pages'
import Loading from '../../components/pages/loading'
import StepLine from '../../components/core/stepLine'
import jsPDF from 'jspdf'
import { font } from '../../utils/font'
import { getWatermarkDataUrl } from '../../utils/watermark'
import { calculateOfficialPayroll } from '../Calculator1/payrollCalculator2026'

const formatCurrency = (val) => {
  const num = Number(val) || 0
  const [int, dec] = num.toFixed(2).split('.')
  return int.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + '.' + dec + ' ₼'
}


const DonutChart = ({ calcData, language }) => {
  const total = Number(calcData.superGross) || 1;
  const net = Number(calcData.net) || 0;
  const tax = Number(calcData.incomeTax) || 0;
  const employeeSocial = (Number(calcData.dsmfEmployee) || 0) + (Number(calcData.itsEmployee) || 0) + (Number(calcData.unemploymentEmployee) || 0) + (Number(calcData.unionFee) || 0);
  const employerCost = Number(calcData.totalEmployerCost) || 0;

  const netPct = (net / total) * 100;
  const taxPct = (tax / total) * 100;
  const empSocPct = (employeeSocial / total) * 100;
  const employerPct = (employerCost / total) * 100;

  const C = 2 * Math.PI * 65; // ~408.4

  const netStroke = (netPct / 100) * C;
  const taxStroke = (taxPct / 100) * C;
  const empSocStroke = (empSocPct / 100) * C;
  const employerStroke = (employerPct / 100) * C;

  const offset1 = 0;
  const offset2 = -netStroke;
  const offset3 = -(netStroke + taxStroke);
  const offset4 = -(netStroke + taxStroke + empSocStroke);

  return (
    <div className={styles.donutBox}>
      <div className={styles.donutWrap}>
        <svg width="180" height="180" viewBox="0 0 160 160">
          <circle cx="80" cy="80" r="65" fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth="18" />
          {/* Net (Royal Blue) */}
          <circle
            cx="80" cy="80" r="65" fill="none"
            stroke="#416db4" strokeWidth="18"
            strokeDasharray={`${netStroke} ${C - netStroke}`}
            strokeDashoffset={offset1}
            strokeLinecap="round"
            transform="rotate(-90 80 80)"
          />
          {/* Tax (Red/Rose) */}
          {tax > 0 && (
            <circle
              cx="80" cy="80" r="65" fill="none"
              stroke="#f43f5e" strokeWidth="18"
              strokeDasharray={`${taxStroke} ${C - taxStroke}`}
              strokeDashoffset={offset2}
              strokeLinecap="round"
              transform="rotate(-90 80 80)"
            />
          )}
          {/* Employee Social (Gold/Amber) */}
          {employeeSocial > 0 && (
            <circle
              cx="80" cy="80" r="65" fill="none"
              stroke="#e1bc24" strokeWidth="18"
              strokeDasharray={`${empSocStroke} ${C - empSocStroke}`}
              strokeDashoffset={offset3}
              strokeLinecap="round"
              transform="rotate(-90 80 80)"
            />
          )}
          {/* Employer Cost (Teal/Emerald) */}
          {employerCost > 0 && (
            <circle
              cx="80" cy="80" r="65" fill="none"
              stroke="#10b981" strokeWidth="18"
              strokeDasharray={`${employerStroke} ${C - employerStroke}`}
              strokeDashoffset={offset4}
              strokeLinecap="round"
              transform="rotate(-90 80 80)"
            />
          )}
        </svg>
        <div className={styles.donutCenter}>
          <strong>{Math.round(netPct)}%</strong>
          <span>{language === 'AZ' ? 'Xalis Payı' : 'Net Share'}</span>
        </div>
      </div>

      <div className={styles.donutLegend}>
        <div className={styles.legendItem}>
          <span style={{ background: '#416db4' }} />
          <p>{language === 'AZ' ? 'Xalis (Net)' : 'Net'}: <strong>{formatCurrency(calcData.net)}</strong></p>
        </div>
        <div className={styles.legendItem}>
          <span style={{ background: '#f43f5e' }} />
          <p>{language === 'AZ' ? 'Gəlir Vergisi' : 'Tax'}: <strong>{formatCurrency(calcData.incomeTax)}</strong></p>
        </div>
        <div className={styles.legendItem}>
          <span style={{ background: '#e1bc24' }} />
          <p>{language === 'AZ' ? 'İşçi Sosial & İTS' : 'Employee Social'}: <strong>{formatCurrency(employeeSocial)}</strong></p>
        </div>
        <div className={styles.legendItem}>
          <span style={{ background: '#10b981' }} />
          <p>{language === 'AZ' ? 'İşəgötürən Xərci' : 'Employer Cost'}: <strong>{formatCurrency(calcData.totalEmployerCost)}</strong></p>
        </div>
      </div>
    </div>
  );
};

const Result1 = ({ className }) => {
  const params = useParams()
  const { language } = useContext(PageContext)
  const [load, setLoad] = useState(false)
  const [calcData, setCalcData] = useState(null)

  useEffect(() => {
    (async () => {
      try {
        await PagesAPI.getMagazinePageInfo()
      } catch (e) {}

      // Try reading from sessionStorage
      let stored = null
      try {
        const raw = sessionStorage.getItem('payroll_result_2026')
        if (raw) stored = JSON.parse(raw)
      } catch (e) {}

      if (stored && stored.gross) {
        setCalcData(stored)
      } else {
        // Fallback: recalculate from URL params
        const grossParam = parseFloat(params.emekHaqqi) || 2500
        const vmParam = parseFloat(params.vm) || 0
        const res = calculateOfficialPayroll({
          amount: grossParam,
          sector: 'PRIVATE',
          workplaceType: 'MAIN',
          unionFeePercent: parseFloat(params.hemkarlar) ? (parseFloat(params.hemkarlar) / grossParam * 100) : 0,
          exemptionAmount: vmParam,
          year: 2026
        }, 'GROSS_TO_NET')
        setCalcData({
          ...res,
          year: 2026,
          workplaceType: 'MAIN',
          sectorName: language === 'AZ' ? 'Qeyri-dövlət və qeyri-neft sektoru' : 'Private Sector'
        })
      }
      setLoad(true)
    })()
  }, [language])

  const steps = [
    {
      title: translate.calculation_type,
      text: translate.make_your_choice,
    },
    {
      title: translate.basic_information,
      text: translate.enter_info,
    },
    {
      title: translate.result,
      text: translate.ready,
    },
  ]

  const generatePdf = async () => {
    if (!calcData) return
    const watermarkData = await getWatermarkDataUrl()
    const pdf = new jsPDF('p', 'mm', 'a4')
    pdf.addFileToVFS('WorkSans-normal.ttf', font)
    pdf.addFont('WorkSans-normal.ttf', 'WorkSans', 'normal')
    pdf.setFont('WorkSans')

    // Page 1 Background Watermark (Large format BPG logo, monochrome & subtle)
    if (watermarkData) {
      pdf.addImage(watermarkData, 'PNG', 30, 110, 150, 46)
    }

    // Header
    pdf.setFontSize(16)
    pdf.setTextColor(22, 111, 229)
    pdf.text('BPG CONSULTING CENTRE', 20, 25)

    pdf.setFontSize(13)
    pdf.setTextColor(30, 41, 59)
    pdf.text(`Əməkhaqqından Tutulmalar və Maya Dəyəri Hesabatı (2026 Standartı)`, 20, 35)

    pdf.setFontSize(10)
    pdf.setTextColor(100, 116, 139)
    pdf.text(`İl: 2026 | Hesablama Tarixi: ${new Date().toLocaleDateString('az-AZ')} | İş Yeri: ${calcData.workplaceType === 'MAIN' ? 'Əsas İş Yeri' : 'Əlavə İş Yeri'}`, 20, 42)

    // Table 1: Employee
    pdf.setFontSize(12)
    pdf.setTextColor(22, 111, 229)
    pdf.text('1. MUZDLU İŞÇİNİN ƏMƏKHAQQINDAN TUTULMALAR', 20, 54)

    let y = 62
    const employeeRows = [
      ['Hesablanan Əməkhaqqı (Gross):', formatCurrency(calcData.gross)],
      ['Vergi Güzəşti (Maddə 102):', formatCurrency(calcData.exemptionAmount)],
      ['Baza Güzəşti (Əsas iş yeri):', formatCurrency(calcData.basicRelief)],
      ['Vergiyə Cəlb Olunan Gəlir Bazası:', formatCurrency(calcData.taxableIncome)],
      ['Gəlir Vergisi (İşçi):', formatCurrency(calcData.incomeTax)],
      ['DSMF Ayırması (İşçi):', formatCurrency(calcData.dsmfEmployee)],
      ['İcbari Tibbi Sığorta (İşçi):', formatCurrency(calcData.itsEmployee)],
      ['İşsizlikdən Sığorta (İşçi - 0.5%):', formatCurrency(calcData.unemploymentEmployee)],
      ['Həmkarlar İttifaqı Haqqı:', formatCurrency(calcData.unionFee || 0)],
      ['Cəmi Tutulmalar:', formatCurrency(calcData.totalEmployeeDeductions)],
      ['XALİS ƏMƏKHAQQI (NET / Ələ Çatan):', formatCurrency(calcData.net)],
    ]

    pdf.setFontSize(10)
    employeeRows.forEach(([lbl, val]) => {
      pdf.setTextColor(71, 85, 105)
      pdf.text(lbl, 25, y)
      pdf.setTextColor(15, 23, 42)
      pdf.text(val, 150, y, { align: 'right' })
      pdf.setDrawColor(241, 245, 249)
      pdf.line(25, y + 2, 185, y + 2)
      y += 8
    })

    // Table 2: Employer
    y += 10
    pdf.setFontSize(12)
    pdf.setTextColor(13, 148, 136)
    pdf.text('2. İŞƏGÖTÜRƏNİN XƏRCLƏRİ (ŞİRKƏTƏ MAYA DƏYƏRİ)', 20, y)

    y += 8
    const employerRows = [
      ['Hesablanan Gross Əməkhaqqı:', formatCurrency(calcData.gross)],
      ['İşəgötürən DSMF Ayırması:', formatCurrency(calcData.dsmfEmployer)],
      ['İşəgötürən İcbari Tibbi Sığorta:', formatCurrency(calcData.itsEmployer)],
      ['İşəgötürən İşsizlikdən Sığorta (0.5%):', formatCurrency(calcData.unemploymentEmployer)],
      ['İşəgötürənin Sosial Öhdəlikləri Cəmi:', formatCurrency(calcData.totalEmployerCost)],
      ['CƏMİ MAYA DƏYƏRİ (SUPER GROSS):', formatCurrency(calcData.superGross)],
    ]

    pdf.setFontSize(10)
    employerRows.forEach(([lbl, val]) => {
      pdf.setTextColor(71, 85, 105)
      pdf.text(lbl, 25, y)
      pdf.setTextColor(15, 23, 42)
      pdf.text(val, 150, y, { align: 'right' })
      pdf.setDrawColor(241, 245, 249)
      pdf.line(25, y + 2, 185, y + 2)
      y += 8
    })

    // Footer note Page 1
    y += 8
    pdf.setFontSize(8.5)
    pdf.setTextColor(148, 163, 184)
    pdf.text('Hesabat AR Vergi Məcəlləsi (Maddə 101.3 & 102.1.6) və 2026-cı il rəsmi qanunvericiliyinə əsasən tərtib edilmişdir.', 20, y)
    pdf.text('Ətraflı qanunvericilik maddələri və izahatlar növbəti səhifədə təqdim edilir | BPG Consulting Centre', 20, y + 4.5)

    // ==========================================
    // PAGE 2: RƏSMİ QANUNVERİCİLİK BAZASI VƏ İZAHATLAR
    // ==========================================
    pdf.addPage()

    // Page 2 Background Watermark (Large format BPG logo, monochrome & subtle)
    if (watermarkData) {
      pdf.addImage(watermarkData, 'PNG', 30, 110, 150, 46)
    }

    pdf.setFontSize(15)
    pdf.setTextColor(22, 111, 229)
    pdf.text('BPG CONSULTING CENTRE', 20, 22)

    pdf.setFontSize(12)
    pdf.setTextColor(30, 41, 59)
    pdf.text('Rəsmi Qanunvericilik Bazası və Hüquqi İzahatlar (2026 Standartı)', 20, 31)

    pdf.setDrawColor(226, 232, 240)
    pdf.line(20, 36, 190, 36)

    let py = 46

    // Section A: AR Vergi Məcəlləsi
    pdf.setFontSize(10.5)
    pdf.setTextColor(22, 111, 229)
    pdf.text('A. AZƏRBAYCAN RESPUBLİKASININ VERGİ MƏCƏLLƏSİ', 20, py)
    py += 7

    const vmPoints = [
      ['Maddə 101.3 (Qeyri-neft/özəl sektorda vergi dərəcəsi):', 'Qeyri-dövlət və qeyri-neft sektorunda muzdlu işçilərin aylıq gəlirindən 8000 manatadək 0%, 8000 manatdan çox olan məbləğdən isə 14% dərəcəsi ilə gəlir vergisi tutulur. Dövlət və neft sektorunda isə 2500 manatadək 14%, artıq hissəyə 25% tətbiq edilir.'],
      ['Maddə 102.1.6 (Əsas iş yerində baza vergi güzəşti):', 'Fiziki şəxsin əsas iş yerində hər hansı muzdlu işlə əlaqədar əldə etdiyi aylıq gəliri 2500 manatadək olduqda, gəlirin 200 manat məbləğində olan hissəsi gəlir vergisindən azad edilir.'],
      ['Maddə 102.2 (Əlavə vergi güzəştləri):', 'Qanunvericiliklə müəyyən edilmiş kateqoriyalara aid şəxslərə (şəhid ailələri, müharibə veteranları, əlilliyi olan şəxslər və s.) müvafiq məbləğlərdə aylıq əlavə vergi azadolması hüququ tanınır.'],
    ]

    pdf.setFontSize(8.5)
    vmPoints.forEach(([title, desc]) => {
      pdf.setTextColor(15, 23, 42)
      pdf.text(title, 22, py)
      py += 4.5
      pdf.setTextColor(71, 85, 105)
      const splitDesc = pdf.splitTextToSize(desc, 168)
      pdf.text(splitDesc, 25, py)
      py += splitDesc.length * 4.2 + 3
    })

    // Section B: Sosial və Tibbi Sığorta Qanunvericiliyi
    py += 3
    pdf.setFontSize(10.5)
    pdf.setTextColor(22, 111, 229)
    pdf.text('B. SOSİAL, TİBBİ VƏ İŞSİZLİKDƏN SIĞORTA QANUNVERİCİLİYİ', 20, py)
    py += 7

    const insPoints = [
      ['«Sosial sığorta haqqında» AR Qanunu (Maddə 14):', 'Qeyri-neft/özəl sektorda: 200 manatadək hissədən 3% işçi, 22% işəgötürən; 200 manatdan çox hissədən 10% işçi, 15% işəgötürən ödənir. Dövlət və neft sektorunda: 3% işçi, 22% işəgötürən hesablanır.'],
      ['«Tibbi sığorta haqqında» AR Qanunu (İcbari Tibbi Sığorta):', 'Aylıq gəlirin 8000 manatadək hissəsindən 2% işçi, 2% işəgötürən; 8000 manatdan yuxarı hissəsindən isə 0.5% işçi, 0.5% işəgötürən tərəfindən ödənilir.'],
      ['«İşsizlikdən sığorta haqqında» AR Qanunu:', 'Hesablanmış əməkhaqqı fondundan 0.5% işçi və 0.5% işəgötürən tərəfindən məcburi sığorta haqqı ödənilir.'],
    ]

    pdf.setFontSize(8.5)
    insPoints.forEach(([title, desc]) => {
      pdf.setTextColor(15, 23, 42)
      pdf.text(title, 22, py)
      py += 4.5
      pdf.setTextColor(71, 85, 105)
      const splitDesc = pdf.splitTextToSize(desc, 168)
      pdf.text(splitDesc, 25, py)
      py += splitDesc.length * 4.2 + 3
    })

    // Section C: Əmək Məcəlləsi Qeydləri
    py += 3
    pdf.setFontSize(10.5)
    pdf.setTextColor(22, 111, 229)
    pdf.text('C. ƏMƏK MƏCƏLLƏSİ VƏ ŞİRKƏT XƏRCLƏRİ (SUPER GROSS)', 20, py)
    py += 7

    const emPoints = [
      ['AR Əmək Məcəlləsi Maddə 157:', 'Əməkhaqqı işçinin gördüyü işin müqabilində işəgötürən tərəfindən pul formasında ödənilən gündəlik və ya aylıq məbləğdir.'],
      ['Super Gross (Şirkətə Cəmi Maya Dəyəri):', 'İşçiyə hesablanan Gross əməkhaqqı ilə yanaşı, işəgötürənin dövlət büdcəsinə və sosial fondlara ödədiyi sosial sığorta (22% və ya 15%), icbari tibbi sığorta (2%) və işsizlikdən sığorta (0.5%) xərclərinin məcmusudur.'],
    ]

    pdf.setFontSize(8.5)
    emPoints.forEach(([title, desc]) => {
      pdf.setTextColor(15, 23, 42)
      pdf.text(title, 22, py)
      py += 4.5
      pdf.setTextColor(71, 85, 105)
      const splitDesc = pdf.splitTextToSize(desc, 168)
      pdf.text(splitDesc, 25, py)
      py += splitDesc.length * 4.2 + 3
    })

    // Page 2 Bottom Stamp & Brand
    py += 5
    pdf.setDrawColor(226, 232, 240)
    pdf.line(20, py, 190, py)
    py += 6
    pdf.setFontSize(8)
    pdf.setTextColor(100, 116, 139)
    pdf.text('BPG Consulting Centre MMC | Hüquq, Vergi və Mühasibatlıq Konsaltinq Mərkəzi', 20, py)
    pdf.text('Vebsayt: https://bpgconsulting.az | Telefon: +994 (55) 424 81 26', 20, py + 4.5)

    pdf.save('BPG_Emekhaqqi_Hesabat_2026.pdf')
  }

  return load && calcData ? (
    <section className={`${styles.container} ${className}`}>
      <Useful search={false} />
      <div className={styles.stepline}>
        <StepLine active={2} data={steps} />
      </div>

      <h1>{translate.calculation_result[language]} (2026)</h1>

      <div className={styles.resultGrid}>
        {/* Card 1: Employee */}
        <div className={styles.resultCard}>
          <div className={styles.cardHeader}>
            <h3>
              {language === 'AZ' ? 'İşçinin Əməkhaqqından Tutulmalar' :
               language === 'RU' ? 'Удержания с работника' :
               language === 'TR' ? 'Çalışanın Maaşından Yapılan Kesintiler' :
               'Employee Deductions'}
            </h3>
            <span>
              {calcData.workplaceType === 'MAIN'
                ? (language === 'AZ' ? 'Əsas İş Yeri' : language === 'RU' ? 'Основное место работы' : language === 'TR' ? 'Asıl İş Yeri' : 'Main Workplace')
                : (language === 'AZ' ? 'Əlavə İş Yeri' : language === 'RU' ? 'Дополнительное место работы' : language === 'TR' ? 'Ek İş Yeri' : 'Additional Workplace')}
            </span>
          </div>

          <div className={styles.mainHighlight}>
            <p>
              {language === 'AZ' ? 'Xalis Əməkhaqqı (Net / Ələ çatan)' :
               language === 'RU' ? 'Чистая зарплата (Net)' :
               language === 'TR' ? 'Net Ele Geçen Maaş (Net)' :
               'Net Salary (Take Home)'}
            </p>
            <h2>{formatCurrency(calcData.net)}</h2>
          </div>

          <ul className={styles.breakdownList}>
            <li>
              <span>{language === 'AZ' ? 'İl:' : language === 'RU' ? 'Год:' : language === 'TR' ? 'Yıl:' : 'Year:'}</span>
              <strong>2026</strong>
            </li>
            <li>
              <span>{language === 'AZ' ? 'Hesablanan Əməkhaqqı (Gross):' : language === 'RU' ? 'Начисленная зарплата (Gross):' : language === 'TR' ? 'Brüt Maaş (Gross):' : 'Gross Salary:'}</span>
              <strong>{formatCurrency(calcData.gross)}</strong>
            </li>
            {calcData.basicRelief > 0 && (
              <li>
                <span>{language === 'AZ' ? 'Baza Güzəşti (Əsas iş yeri):' : language === 'RU' ? 'Базовая льгота (Основное место):' : language === 'TR' ? 'Temel Muafiyet (Asıl iş yeri):' : 'Basic Relief (Main Workplace):'}</span>
                <strong>{formatCurrency(calcData.basicRelief)}</strong>
              </li>
            )}
            {calcData.exemptionAmount > 0 && (
              <li>
                <span>{language === 'AZ' ? 'Vergi Güzəşti (Maddə 102):' : language === 'RU' ? 'Налоговая льгота (Ст. 102):' : language === 'TR' ? 'Vergi Muafiyeti (Madde 102):' : 'Tax Exemption (Art. 102):'}</span>
                <strong>{formatCurrency(calcData.exemptionAmount)}</strong>
              </li>
            )}
            <li>
              <span>{language === 'AZ' ? 'Vergiyə Cəlb Olunan Baza:' : language === 'RU' ? 'Налогооблагаемая база:' : language === 'TR' ? 'Vergiye Tabi Matrah:' : 'Taxable Income Base:'}</span>
              <strong>{formatCurrency(calcData.taxableIncome)}</strong>
            </li>
            <li className={styles.minus}>
              <span>{language === 'AZ' ? 'Gəlir Vergisi (İşçi):' : language === 'RU' ? 'Подоходный налог (Работник):' : language === 'TR' ? 'Gelir Vergisi (Çalışan):' : 'Income Tax (Employee):'}</span>
              <strong>- {formatCurrency(calcData.incomeTax)}</strong>
            </li>
            <li className={styles.minus}>
              <span>{language === 'AZ' ? 'DSMF Ayırması (İşçi):' : language === 'RU' ? 'Соцстрах (Работник):' : language === 'TR' ? 'Sosyal Güvenlik Primi (Çalışan):' : 'Social Security (Employee):'}</span>
              <strong>- {formatCurrency(calcData.dsmfEmployee)}</strong>
            </li>
            <li className={styles.minus}>
              <span>{language === 'AZ' ? 'İcbari Tibbi Sığorta (İşçi):' : language === 'RU' ? 'Медстрахование (Работник):' : language === 'TR' ? 'Sağlık Sigortası (Çalışan):' : 'Health Insurance (Employee):'}</span>
              <strong>- {formatCurrency(calcData.itsEmployee)}</strong>
            </li>
            <li className={styles.minus}>
              <span>{language === 'AZ' ? 'İşsizlikdən Sığorta (0.5%):' : language === 'RU' ? 'Страхование от безработицы (0.5%):' : language === 'TR' ? 'İşsizlik Sigortası (%0.5):' : 'Unemployment (0.5%):'}</span>
              <strong>- {formatCurrency(calcData.unemploymentEmployee)}</strong>
            </li>
            {calcData.unionFee > 0 && (
              <li className={styles.minus}>
                <span>{language === 'AZ' ? 'Həmkarlar İttifaqı Haqqı:' : language === 'RU' ? 'Профсоюзный взнос:' : language === 'TR' ? 'Sendika Aidatı:' : 'Trade Union Fee:'}</span>
                <strong>- {formatCurrency(calcData.unionFee)}</strong>
              </li>
            )}
            <li className={styles.finalRow}>
              <span>{language === 'AZ' ? 'Cəmi Tutulmalar:' : language === 'RU' ? 'Всего удержаний:' : language === 'TR' ? 'Toplam Kesintiler:' : 'Total Deductions:'}</span>
              <strong>{formatCurrency(calcData.totalEmployeeDeductions)}</strong>
            </li>
          </ul>
        <DonutChart calcData={calcData} language={language} />
        </div>

        {/* Card 2: Employer Costs (Super Gross) */}
        <div className={styles.resultCard}>
          <div className={styles.cardHeader}>
            <h3>{language === 'AZ' ? 'İşəgötürənin Xərcləri' : language === 'RU' ? 'Расходы работодателя' : language === 'TR' ? 'İşverenin Maliyetleri' : 'Employer Costs'}</h3>
            <span style={{ background: '#f0fdf4', color: '#16a34a' }}>Super Gross</span>
          </div>

          <div className={`${styles.mainHighlight} ${styles.employerHighlight}`}>
            <p>{language === 'AZ' ? 'Ümumi Maya Dəyəri (Super Gross)' : language === 'RU' ? 'Полные расходы работодателя' : language === 'TR' ? 'Toplam İşveren Maliyeti (Super Gross)' : 'Total Employer Cost'}</p>
            <h2>{formatCurrency(calcData.superGross)}</h2>
          </div>

          <ul className={styles.breakdownList}>
            <li>
              <span>{language === 'AZ' ? 'Hesablanan Gross Əməkhaqqı:' : language === 'RU' ? 'Начисленный Gross:' : language === 'TR' ? 'Brüt Maaş (Gross):' : 'Gross Salary:'}</span>
              <strong>{formatCurrency(calcData.gross)}</strong>
            </li>
            <li>
              <span>{language === 'AZ' ? 'İşəgötürən DSMF Ayırması:' : language === 'RU' ? 'Соцстрах (Работодатель):' : language === 'TR' ? 'İşveren Sosyal Güvenlik Payı:' : 'Employer Social Security:'}</span>
              <strong>+ {formatCurrency(calcData.dsmfEmployer)}</strong>
            </li>
            <li>
              <span>{language === 'AZ' ? 'İşəgötürən İcbari Tibbi Sığorta:' : language === 'RU' ? 'Медстрахование (Работодатель):' : language === 'TR' ? 'İşveren Sağlık Sigortası:' : 'Employer Health Insurance:'}</span>
              <strong>+ {formatCurrency(calcData.itsEmployer)}</strong>
            </li>
            <li>
              <span>{language === 'AZ' ? 'İşəgötürən İşsizlikdən Sığorta (0.5%):' : language === 'RU' ? 'Безработица (Работодатель 0.5%):' : language === 'TR' ? 'İşveren İşsizlik Sigortası (%0.5):' : 'Employer Unemployment (0.5%):'}</span>
              <strong>+ {formatCurrency(calcData.unemploymentEmployer)}</strong>
            </li>
            <li className={styles.finalRow}>
              <span>{language === 'AZ' ? 'Sosial Öhdəliklər Cəmi:' : language === 'RU' ? 'Итого соцобязательства:' : language === 'TR' ? 'Toplam Sosyal Yükümlülükler:' : 'Total Employer Social Costs:'}</span>
              <strong>{formatCurrency(calcData.totalEmployerCost)}</strong>
            </li>
            <li className={styles.finalRow}>
              <span>{language === 'AZ' ? 'Yekun Şirkət Məsrəfi:' : language === 'RU' ? 'Итоговая стоимость для компании:' : language === 'TR' ? 'Toplam Şirket Maliyeti:' : 'Total Cost to Company:'}</span>
              <strong style={{ color: '#0d9488' }}>{formatCurrency(calcData.superGross)}</strong>
            </li>
          </ul>
        </div>
      </div>

      <div className={styles.buttons}>
        <Button to={'/useful/calculator/1'}>{translate.again[language]}</Button>
        <FormButton onClick={() => generatePdf()}>
          {translate.pdf[language]}
        </FormButton>
      </div>
    
      {/* Sticky Mobile Summary Bar (< 768px) */}
      <div className={styles.stickyMobileSummary}>
        <div>
          <span>{language === 'AZ' ? 'Xalis Əməkhaqqı (Net):' : 'Net Salary:'}</span>
          <strong>{formatCurrency(calcData.net)}</strong>
        </div>
        <button type="button" onClick={() => downloadPDF()} className={styles.stickyPdfBtn}>
          📄 PDF
        </button>
      </div>
  
    </section>
  ) : (
    <Loading />
  )
}

export default Result1
